import Vue from 'vue';
import Vuex from 'vuex';

import setup from '@/store/modules/setup';
import page from '@/store/modules/page';
import message from '@/store/modules/message';

import shop from '@/extensions/shop/store/modules/shop';
import auth from '@/extensions/restricted-area/store/modules/auth';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    setup, // global
    page, // global
    message, // namespaced

    // extensions
    auth, // namespaced
    shop // namespaced
  },
  strict: debug
});

export default store;
